import { Component, ComponentType } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ISharedVideoState } from "../../interfaces/states/ISharedVideoState";
import queryString from 'query-string';
import React from "react";
import ReactPlayer from "react-player";
import { compose } from "redux";
import { annexesService } from "../../services";
import './index.scss';

interface ISharedVideoRouteParams {
    id: string;
}

type SharedVideoProps = RouteComponentProps<ISharedVideoRouteParams> & WithTranslation;
type SharedVideoState = ISharedVideoState;

class SharedVideo extends Component<SharedVideoProps, SharedVideoState> {
    public constructor(props: SharedVideoProps) {
        super(props);
        this.state = {
            id: '',
            videoUrl: '',
            videoTitle: '',
            hasError: false
        };
    }

    public componentDidMount = async () => {
        let currentId: string = null;
        const parsedUrl = queryString.parse(this.props.location.search);
        if (parsedUrl.id) {
            currentId = parsedUrl.id as string;
        }
        if (this.props.match.params.id) {
            currentId = this.props.match.params.id;
        } else {
            const parsedUrl = queryString.parse(this.props.location.search);
            if (parsedUrl.id) {
                currentId = parsedUrl.id as string;
            }
        }
        if (currentId) {
            try {
              const annexeInfo = await annexesService.getVideoAnnexeInfo(currentId);
              this.setState({
                id: annexeInfo.id,
                videoUrl: annexeInfo.fileName,
                videoTitle: annexeInfo.description                    
              });
            } catch (error: any) {
              if (error['410']) {
                this.props.history.push('/410');
              } else {
                let errorMessage = '';
                for (const property in error) {
                  if (Object.prototype.hasOwnProperty.call(error, property)) {
                    errorMessage += property + ': ' + error[property] + '\n';
                  }
                }
      
                this.setState({ hasError: true });
                console.error(errorMessage);
              }
      
              return;
            }
          }
    }

    public render(): JSX.Element {
        const { i18n } = this.props;

        return (
            <>
                <div className='container mt3'>
                    {this.state.hasError
                        ? <div className='meta-container'>
                            <div className='p-3 align-items-center' style={{ textAlign: 'center', fontSize: 'x-large' }}>
                                <span>{i18n.t('annexVideo.notFound')}</span>
                            </div>
                        </div>
                        : <>
                            <div className='meta-container'>
                                <div className='row p-3 align-items-end'>
                                    <div className='col-12 video'>
                                        <ReactPlayer
                                            url={this.state.videoUrl}
                                            controls={true}
                                            // Disable download button
                                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                                            // Disable right click
                                            onContextMenu={(e: any) => e.preventDefault()}
                                            playing={true}
                                            className='aspect-ratio-16-9'
                                        />
                                    </div>
                                </div>
                            </div>
                        </>}
                </div>
            </>
        );
    }
}

export default compose(
    withRouter,
    withTranslation()
)(SharedVideo) as ComponentType;